export const logOut = () => {
  localStorage.removeItem('meestJwt');
  localStorage.removeItem('expirationTime');
  localStorage.removeItem('user');
  window.location.href = '/';
};

export const setJwt = (jwt) => {
  const time = new Date();
  time.setHours(time.getHours() + 8);
  localStorage.setItem('meestJwt', jwt);
  localStorage.setItem('expirationTime', time);
  window.location.href = '/';
};

export const setCurrentUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const jwtToken = localStorage.getItem('meestJwt');
export const expirationTime = new Date(localStorage.getItem('expirationTime'));
export const currentUser = JSON.parse(localStorage.getItem('user'));
export const shipmentsReadOnly = currentUser?.shipments === 'read';

export const isAuthExpired = () => {
  const now = new Date();
  if (now.getTime() > expirationTime?.getTime() && jwtToken) {
    logOut();
  }
};

export const isAuthorized = Boolean(localStorage.getItem('meestJwt'));
